/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { TDictionary } from '../../../util/types';

type ApiStatus = 'idle' | 'pending' | 'fulfilled' | 'error';

export interface NutritionPromoConfig {
  enabled: boolean;
  startMonth: Date;
  // Add other config properties here if needed
}

export interface NutritionPromoPrice {
  location: string;
  price: number;
}

export interface NutritionPromoItem {
  name: string;
  key: string;
  minQuantity: number;
  spread: number | null;
  minSpread: number | null;
  maxSpread: number | null;
  unitMultiple: number;
  unitLabel: string;
  prices: NutritionPromoPrice[];
}

interface OrderSpreadLineItem {
  key: string;
  name: string;
  quantity: number;
  price: number | null;
  location: string;
  spreads: Spread[];
}

export interface PromotionOrderPayload {
  accountNumber: string;
  customerName: string;
  email: string;
  phone: string;
  notes: string;
  products: OrderSpreadLineItem[];
}

export interface NutritionPromoResponse {
  config: NutritionPromoConfig;
  products: NutritionPromoItem[];
  dictionary: TDictionary<NutritionPromoItem[]>;
}

export interface NutritionPromoState {
  promo: NutritionPromoResponse;
  getStatus: ApiStatus;
  submitStatus: ApiStatus;
}

export interface Spread {
  month: Date;
  quantity: number;
}

export type SelectedPromo = NutritionPromoItem & {
  name: string;
  quantity: number;
  price: number;
  location: string;
  spreads: Spread[];

  // State only
  error?: 'total' | 'min' | 'max';
  errorMsg?: string;
};
